import { Reveal } from "@/components/landing/Reveal";

const nodes = [
  { day: "Day 1", title: "Guwahati Arrival → Umiam Lake → Shillong", body: "Private morning airport pickup. Tea and snacks overlooking the mist on Umiam Lake before a relaxed check-in." },
  { day: "Day 2", title: "Deep Culture & Sacred Groves", body: "Walk the ridges of Laitlum Canyons. Explore the Mawphlang Sacred Forest with a local Khasi guide." },
  { day: "Day 3", title: "Into the Land of Clouds", body: "Travel to Sohra (Cherrapunji). Stand above Nohkalikai Falls and explore underground limestone caves." },
  {
    day: "Day 4",
    title: "Choose Your Own Pacing — The Split-Track Day",
    body: "A conflict-free day designed for mixed generations.",
    tracks: [
      { label: "Track A · The Explorer", text: "Guided trek down to the Double Decker Living Root Bridge." },
      { label: "Track B · The Slow Trail", text: "Hidden waterfalls, artisan villages, and valley-view cafés." },
    ],
  },
  { day: "Day 5", title: "The Crystal Clear River Day", body: "Unhurried relaxation on the banks of the Umngot River in Shnongpdeng. Traditional wooden boat ride and a stroll through Mawlynnong village." },
  { day: "Day 6", title: "Guwahati Airport Departure", body: "A smooth, comfortable private transfer back to the airport timed perfectly to your return flight." },
];

export const Itinerary = () => (
  <section className="relative overflow-hidden bg-ink px-7 py-24 grain sm:px-12 lg:px-20 lg:py-32" data-testid="itinerary-section">
    <div className="relative z-10 mx-auto max-w-4xl">
      <Reveal className="mb-20 text-center">
        <p className="eyebrow text-gold mb-5">The Signature Itinerary</p>
        <h2 className="font-display text-4xl leading-tight text-white sm:text-5xl lg:text-6xl">
          Mighty Meghalaya: <span className="italic text-gold">Unscripted Luxury</span>
        </h2>
      </Reveal>

      <div className="relative">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-white/15 md:left-1/2 md:-translate-x-1/2" />
        <div className="space-y-14">
          {nodes.map((n, i) => (
            <Reveal key={n.day} delay={0.05}>
              <div className={`relative flex md:items-center ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}>
                <span className="absolute left-0 top-1.5 z-10 h-4 w-4 rounded-full border-2 border-gold bg-ink md:left-1/2 md:-translate-x-1/2" />
                <div className="w-full pl-10 md:w-1/2 md:pl-0 md:px-10">
                  <div className={`border border-white/10 bg-surface p-7 transition-colors duration-300 hover:border-gold/40 ${i % 2 === 0 ? "md:text-right" : ""}`} data-testid={`itinerary-node-${i}`}>
                    <span className="eyebrow text-gold">{n.day}</span>
                    <h3 className="mt-3 font-display text-xl text-white">{n.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-white/55">{n.body}</p>
                    {n.tracks && (
                      <div className="mt-5 space-y-3">
                        {n.tracks.map((t) => (
                          <div key={t.label} className="border-l-2 border-gold/60 bg-white/5 px-4 py-3 text-left">
                            <p className="text-xs font-bold uppercase tracking-wider text-gold">{t.label}</p>
                            <p className="mt-1 text-sm text-white/65">{t.text}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
